import { TiledGameObject } from "src/games/shared/phaserHelpers/HandyTypes";

export class Animal extends Phaser.GameObjects.Sprite {
    id: number;
    isInHabitat: boolean;
    startingPosition: Phaser.Geom.Point;

    constructor(scene: Phaser.Scene, ob: TiledGameObject) {
        var id = ob.properties["id"] as number;
        super(scene, ob.x + ob.width / 2, ob.y + ob.height / 2, "assets", "animal" + id);
        this.id = id;
        this.name = ob.name;
        this.isInHabitat = false;
        this.type = "Animal";
        this.startingPosition = new Phaser.Geom.Point(this.x, this.y);

        this.setInteractive({ useHandCursor: true });
        this.scene.input.setDraggable(this);
        this.scene.add.existing(this);
    }

    playAnimation(ob) {
        this.scene.anims.create({
            key: ob.name,
            frames: this.scene.anims.generateFrameNames("assets", {
                prefix: ob.name,
                start: 1,
                end: 4
            }),
            frameRate: 6,
            repeat: -1,
            delay: 500 * this.id,
            repeatDelay: 300
        });

        this.anims.play(ob.name);
    }

    putInHabitat(habitat: Habitat) {
        this.setDepth(2);
        this.setFrame(this.frame.name + "Small");
        this.setPosition(habitat.animalPoint.x, habitat.animalPoint.y);
    }

}

export class Food extends Phaser.GameObjects.Sprite {
    id: number;
    isInHabitat: boolean;
    startingPosition: Phaser.Geom.Point;

    constructor(scene: Phaser.Scene, ob: TiledGameObject) {
        var id = ob.properties["id"] as number;

        super(scene, ob.x + ob.width / 2, ob.y + ob.height / 2, "assets", "food" + id);
        this.id = id;
        this.name = ob.name;
        this.isInHabitat = false;
        this.type = "Food";
        this.startingPosition = new Phaser.Geom.Point(this.x, this.y);

        this.setInteractive({ useHandCursor: true });
        this.scene.input.setDraggable(this);
        this.scene.add.existing(this);
    }

    putInHabitat(habitat: Habitat) {
        this.setDepth(3);
        this.setFrame(this.frame.name + "Small");
        this.setPosition(habitat.foodPoint.x, habitat.foodPoint.y);
    }
}

export class Habitat extends Phaser.GameObjects.Zone {
    id: number;
    foodPoint: Phaser.Geom.Point;
    animalPoint: Phaser.Geom.Point;

    constructor(scene: Phaser.Scene, ob: TiledGameObject) {
        super(scene, ob.x + ob.width / 2, ob.y + ob.height / 2, ob.width, ob.height);
        this.id = ob.properties["id"] as number;
        this.name = ob.name;
        this.type = "Habitat";
        this.foodPoint = new Phaser.Geom.Point();
        this.animalPoint = new Phaser.Geom.Point();

        this.setRectangleDropZone(this.width, this.height);

        this.scene.add.existing(this);
    }
}



// WEBPACK FOOTER //
// ./src/games/ZooGame/objects/Animal.ts